import type { Lang } from './i18n';

// App screenshots that also exist per locale at /<dir>/<locale>/<file> (English stays at /<dir>/<file>).
const LOCALIZED = new Set([
  '/images/app-hero-1.webp',
  '/images/app-hero-2.webp',
  '/screenshots/home.png',
  '/screenshots/analytics.png',
  '/screenshots/muscles.png',
  '/screenshots/exercises.png',
  '/screenshots/calendar.png',
  '/screenshots/nutrition.png',
  '/screenshots/training-log.png',
  '/screenshots/reaction.png',
  '/screenshots/activity.png',
  '/screenshots/rank.png',
]);

/** Localized copy of an app screenshot for `lang`, falling back to the English file. */
export function localizedScreenshot(src: string, lang: Lang): string {
  if (lang === 'en' || !LOCALIZED.has(src)) return src;
  const i = src.lastIndexOf('/');
  return `${src.slice(0, i)}/${lang}${src.slice(i)}`;
}
